"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricFailureToCreateError = exports.DuplicateMetricIdError = exports.UnexpectedFilterCreateError = exports.TelemetryTypeError = void 0;
class TelemetryTypeError extends Error {
    constructor(message) {
        super(message);
        this.name = "TelemetryTypeError";
    }
}
exports.TelemetryTypeError = TelemetryTypeError;
class UnexpectedFilterCreateError extends Error {
    constructor(message) {
        super(message);
        this.name = "UnexpectedFilterCreateError";
    }
}
exports.UnexpectedFilterCreateError = UnexpectedFilterCreateError;
class DuplicateMetricIdError extends Error {
    constructor(message) {
        super(message);
        this.name = "DuplicateMetricIdError";
    }
}
exports.DuplicateMetricIdError = DuplicateMetricIdError;
class MetricFailureToCreateError extends Error {
    constructor(message) {
        super(message);
        this.name = "MetricFailureToCreateError";
    }
}
exports.MetricFailureToCreateError = MetricFailureToCreateError;
//# sourceMappingURL=quickpulseErrors.js.map